/**
 * Helpers with no platform underneath them. Anything that reaches for the DOM
 * — `cn`, `downloadBlob`, `isMac` — stays in the web app's own `lib/utils.ts`,
 * which re-exports this module so its call sites did not have to move.
 */

let counter = 0;
export function uid(prefix = 'id'): string {
  counter += 1;
  return `${prefix}_${Date.now().toString(36)}${counter.toString(36)}${Math.random()
    .toString(36)
    .slice(2, 6)}`;
}

export function clamp(v: number, min: number, max: number) {
  return v < min ? min : v > max ? max : v;
}

export function round(v: number, digits = 3) {
  const f = 10 ** digits;
  return Math.round(v * f) / f;
}

export function formatBytes(bytes: number) {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${(bytes / 1024 ** i).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

export function shuffle<T>(arr: T[]): T[] {
  const out = arr.slice();
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

/** Filesystem-safe base name for downloads. */
export function safeName(name: string) {
  return name.trim().replace(/[^\w\-. ]+/g, '').replace(/\s+/g, '-') || 'collage';
}
